import { hDeepCopy } from '@/utils/helpers';
// @vue/component
export default {
  name: 'SurveyPopover',

  components: {
  },

  props: {
    questionsList: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
    isEdited: {
      type: Boolean,
      default: false,
    },
    wh1Uuid: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    preparedAnswers: {
      type: Array,
      default: () => []
    },
    currentOpenSurvey: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      answers: [],
    }
  },

  async created() {
  },
  watch: {
    questionsList: {
      handler() {
        this.answers = [];
        this.questionsList.forEach((item) => {
          if (item._html_type === 'checkbox') {
            this.answers[item._question_id] = [];
          } else {
            this.answers[item._question_id] = "";
          }
          if (this.preparedAnswers.length > 0) {
            this.preparedAnswers.forEach(answer => answer.questionId === item._question_id ? this.answers[item._question_id] = answer.answer : null)
          }
          if (!this.wh1Uuid && item._answer) {
            this.answers[item._question_id] = item._answer
          }

        });
      },
      deep: true,
      immediate: true
    },
  },

  computed: {
    surveyInputTypesList() {
      return this.$store.getters['campaign/surveyInputTypesList'];
    },
  },

  methods: {
    handleCheckbox(value, questionId) {
      if (this.answers[questionId].indexOf(value) === -1) {
        this.answers[questionId].push(value)
      } else {
        this.answers[questionId].splice(this.answers[questionId].indexOf(value), 1)
      }
    },
    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    async submitSurvey() {
      const prepareAnswersForSend = [];
      Object.keys(this.answers).forEach(key => {
        const questionDetails = this.questionsList.filter(question => question._question_id.toString() === key)
        const answerObject = {
          question_uuid: questionDetails[0]._question_uuid,
          wh1_uuid: this.wh1Uuid ? this.wh1Uuid : questionDetails[0]._uuid_wh1,
          answer: this.answers[key]
        };
        if (this.currentOpenSurvey) answerObject.survey_uuid = this.currentOpenSurvey;
        prepareAnswersForSend.push(answerObject);
      });
      const responseStatus = await this.$store.dispatch('campaign/submitSurvey', { answers: prepareAnswersForSend })
      if (responseStatus === 200) {
        this.$message({
          type: 'success',
          message: "Odpowiedzi zostały zapisane.",
        });
        this.$emit('hideSurveyModal');
        this.answers = {};
      } else {
        this.$message({
          type: 'error',
          message: "Wystąpił błąd podczas zapisywania odpowiedzi",
        });
      }
    }
  }
};
